import { useState } from 'react';
import logo from './img/elizak_p.png'
import Config from './Config';

import UstawTermin from './panel/UstawTermin';


function PassForm(props)
{
    const [req, setReq] = useState(
        {            
            password: '',        
        }
    );


    const [msg, setMsg] = useState("");

    const handleChange = (event) => {      
        let fieldName = event.target.name;
        let fieldVal  = event.target.value;
        setReq( {...req,  [fieldName]:fieldVal } );      
    }


    const handleSubmit = (event) => {
        event.preventDefault();            
        sendData();
    }

    const sendData = () => {

        if(req.password.length < 4) return;

        setMsg("");  
        console.log("Param: ", JSON.stringify(req) );

        fetch( Config.url + '/rest_public,video_check_pass', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'text/html'
            }
         })
         .then(res => res.json() )
         .then(res => {

               var status = res.status;

               if( status == 'OK' ) 
               {
                    if(res.det.t0_aktywne == '1')
                    {
                        props.setVideoId(res.det.t0_id);
                    }else
                    {
                        if(res.time > -90)
                        {
                            props.setVideoId(res.det.t0_id);
                           //setMsg("Przepraszamy, aktualnie nie możesz przejść dalej. Prezentacja zostanie rozpoczęta " + res.det.t0_data_rozpoczecia + ". Panel prezentacji będzie wtedy dostępny.");  
                        }else
                        {
                            setMsg("Przepraszamy,  konsultant nadal nie rozpoczął zaplanowanej na " + res.det.t0_data_rozpoczecia + " prezentacji. Skontaktuj się z opiekunem lub spróbuj ponownie później.");
                        }
                    }

                    
               }else
               {
                  setMsg("Podane hasło jest błędne lub prezentacja nie została zaplanowana.");  
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });
                   

         return false;
    }



    var msgDialog = ( <br></br> )
    if(msg.length > 0)
    {
        msgDialog = (
            <div className='msg_error'>{msg}</div>
        )
    }


    return (
        <div className="form_content form_pass">

        <img src={logo} className="img_logo" />

        <div className='welcome'>
           O kurczę! Już tu jesteś
        </div>

        <div className='welcome'>
           i tylko chwila dzieli Cię od poznania wszystkich tajemnic eLizak...  
        </div>

        <div className='welcome2'>
            Jeśli jesteś gotowy podaj magiczne hasło otrzymane od konsultanta. Pamiętaj, hasło jest ważne jedynie w dniu zaplanowanej prezentacji. <br/>Termin prezentacji możesz zmienić po wejściu do panelu.  Zaczynamy? 
        </div>
       
        {msgDialog}    
        <br/>
        <form className="form" onSubmit={handleSubmit}>                                
              <fieldset>
                  <input type="text" value={req.password} onChange={handleChange} name="password" placeholder='Hasło:' className='width100p' />
              </fieldset> 

              <br/>
              <br/>
              <fieldset>
                   <span href='' className='btn' onClick={sendData} >Dołącz do prezentacji VIDEO </span>
              </fieldset> 

        </form>

        <br/><br/><br/>
        <div>
           <h4>Nie masz hasła? <UstawTermin/>  na prezentacje i otrzymaj hasło dostępu. Pamiętaj! Nie musisz <u>nic</u> instalować.</h4>
        </div>
        <br/><br/><br/>
        <div>
            Administratorem przetwarzanych Pana/ Pani danych osobowych jest firma Progress Plus s.c. z siedzibą w Polsce, w Bydgoszczy przy ul. Ołowianej 2. <a className='simply_link' target="_blank" href='https://elizak.edu.pl/rodo'>Pokaż więcej...</a>
        </div>
  </div>
    )
}


export default PassForm;